/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const merchantOrderManageRouter = {
  path: '/manageMerchantAccount',
  component: Layout,
  hidden: false,
  redirect: 'noredirect',
  name: 'ManageMerchantAccount',
  alwaysShow: true,
  meta: {
    title: '商户管理',
    icon: 'merchant',
    roles: ['admin']
  },
  children: [
    {
      path: 'merchantSet',
      component: resolve => require(['@/views/manage/merchantAccountManage/merchantSet'], resolve),//原商户列表
      name: 'MerchantSet',
      meta: { title: '代收商户列表', noCache: false, noKeepAlive: true }
    },
    {
      path: 'merchantPayment',
      component: resolve => require(['@/views/manage/merchantAccountManage/merchantPayment'], resolve),
      name: 'MerchantPayment',
      meta: { title: '代付商户列表', noCache: false, noKeepAlive: true }
    },
    // {
    //   path: 'merchantPayOrder',
    //   component: resolve => require(['@/views/manage/merchantAccountManage/merchantPayOrder'], resolve),
    //   name: 'MerchantPayOrder',
    //   meta: { title: '商户充值订单', noCache: false, noKeepAlive: true }
    // },2023-06-28移到订单管理：网银B2C充值订单
    // {
    //   path: 'merchantWithdrawOrder',
    //   component: resolve => require(['@/views/manage/merchantAccountManage/merchantWithdrawOrder'], resolve),
    //   name: 'MerchantWithdrawOrder',
    //   meta: { title: '商户提现订单', noCache: false, noKeepAlive: true }
    // },//2023-06-28移到财务管理：代收商户提现订单
    // {
    //   path: 'addMerchantApproval',
    //   component: resolve => require(['@/views/manage/merchantAccountManage/addMerchantApproval'], resolve),
    //   name: 'AddMerchantApproval',
    //   meta: { title: '商户审批', noCache: false }
    // },
    // {
    //   path: 'merchantIGroupList',
    //   component: resolve => require(['@/views/manage/merchantGroupManage/merchantIGroupList'], resolve),
    //   name: 'MerchantIGroupList',
    //   meta: { title: '商户组列表', noCache: false }
    // },
    {
      path: 'merchantGroupAdd',
      component: resolve => require(['@/views/manage/merchantGroupManage/merchantGroupAdd'], resolve),
      hidden: true,
      name: 'MerchantGroupAdd',
      meta: { title: '添加商户组', noCache: true, noKeepAlive: true }
    },
    {
      path: 'merchantGroupChannel/:id',
      component: resolve => require(['@/views/manage/merchantGroupManage/merchantGroupChannel'], resolve),
      hidden: true,
      name: 'MerchantGroupChannel',
      meta: { title: '修改商户组通道', noCache: true, noKeepAlive: true }
    },
    // {
    //   path: 'plainBalanceStatistics',
    //   component: resolve => require(['@/views/manage/merchantAccountManage/plainBalanceStatistics'], resolve),
    //   name: 'PlainBalanceStatistics',
    //   meta: { title: '普通商户余额统计', noCache: false }
    // },
    // {
    //   path: 'inventedBalanceStatistics',
    //   component: resolve => require(['@/views/manage/merchantAccountManage/inventedBalanceStatistics'], resolve),
    //   name: 'InventedBalanceStatistics',
    //   meta: { title: '虚拟商户余额统计', noCache: false }
    // },
    {
      path: 'daily-197',
      component: resolve => require(['@/views/manage/merchantAccountManage/daily'], resolve),
      name: 'Daily',
      meta: { title: '商户操作日志', noCache: false }
    },
    {
      path: 'amountAdjustment:list',
      component: resolve => require(['@/views/manage/merchantAccountManage/amountAdjustment'], resolve),
      name: 'amountAdjustment',
      meta: { title: '商户调额记录', noCache: false }
    },
    // {
    //   path: 'risk',
    //   component: resolve => require(['@/views/manage/merchantAccountManage/risk'], resolve),
    //   name: 'Risk',
    //   meta: { title: '风控组列表', noCache: false }
    // },
    // {
    //   path: 'merchantMemberManagement',
    //   component: resolve => require(['@/views/manage/merchantGroupManage/merchantMemberManagement'], resolve),
    //   name: 'MerchantMemberManagement',
    //   meta: { title: '商户会员管理', noCache: false }
    // }
    {
      path: 'robotDaily',
      component: resolve => require(['@/views/manage/merchantAccountManage/robotDaily'], resolve),
      name: 'RobotDaily',
      meta: { title: '机器人日志', noCache: false }
    },
    {
      path: "merchantExchangerate",
      component: resolve => require(["@/views/manage/merchantAccountManage/merchantExchangerate"], resolve),
      name: "MerchantExchangerate",
      meta: { title: "汇率管理", noCache: false }
    },
    {
      path: "merchantGroupV2",
      component: resolve => require(["@/views/manage/merchantGroupV2Manage/index"], resolve),
      name: "MerchantGroupV2",
      meta: { title: "商户组", noCache: false }
    },
  ]
}

export default merchantOrderManageRouter



// WEBPACK FOOTER //
// ./src/router/manage/merchantAccountManage.js